module.exports = __webpack_public_path__ + "img/maximum.3f4fd2a6.jpg";